import { render, staticRenderFns } from "./CertifyCard.vue?vue&type=template&id=668fd954"
import script from "./CertifyCard.vue?vue&type=script&lang=js"
export * from "./CertifyCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports